// src/pages/admin/AdminDashboard.jsx
import React, { useContext, useEffect, useState } from "react";
import { MdPeople } from "react-icons/md";
import { GrCertificate } from "react-icons/gr";
import { PiShoppingCartSimpleThin } from "react-icons/pi";
import { CiBookmarkPlus } from "react-icons/ci";
import { StatsCard } from "../../../layouts/StatsCard";
import { DContext } from "../../../context/Datacontext";
import { useNavigate } from "react-router-dom";
import { CreateUser } from "../../auth/CreateUser";
import WeeklyCourseActivityChart from "./WeeklyCourseActivityChart";
import TopCourses from "./TopCourses";

export const AdminDashboard = () => {
  const {BeURL } = useContext(DContext);
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [counts , setCounts]=useState(null)

      useEffect(() => {
          fetch(`${BeURL}/fetch-count-admin`, {
              method: 'GET',
              credentials: 'include'
          })
              .then(res => res.json())
              .then(data => {
                  if (data.success) {
                      setCounts(data)
                  }
              })
              .catch(err => {
                  console.error('Error in fetch count', err);
              });
      }, [BeURL]);

  return (
    <section className="py-5">
      <div className="max-w-7xl mx-auto px-4 space-y-6">
      {/* stat cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        <StatsCard
          title="Users"
          count={counts?.data?.userCount ?? 0}
          icon={<MdPeople size={20} className="text-white" />}
          overlayClass="from-blue-400 to-indigo-600"
          iconBg="bg-white/30"
          onClick={() => navigate("/app/users")}
        />

        <StatsCard
          title="Courses"
          count={counts?.data?.courseCount ?? 0}
          icon={<GrCertificate size={20} className="text-white" />}
          overlayClass="from-purple-400 to-pink-500"
          iconBg="bg-white/30"
          onClick={() => navigate("/app/courses")}
        />

        <StatsCard
          title="Carts"
          count={counts?.data?.cartCount ?? 0}
          icon={<PiShoppingCartSimpleThin size={20} className="text-white" />}
          overlayClass="from-green-400 to-emerald-500"
          iconBg="bg-white/30"
          onClick={() => navigate("/app/carts")}
        />

        <StatsCard
          title="Orders"
          count={counts?.data?.orderCount ?? 0}
          icon={<CiBookmarkPlus size={20} className="text-white" />}
          overlayClass="from-yellow-400 to-orange-500"
          iconBg="bg-white/30"
          onClick={() => navigate("/app/orders")}
        />
      </div>

      {/* main content area: chart + quick actions */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Chart card */}
        <div className="col-span-2 bg-white rounded-2xl p-6 shadow space-y-3">
          <h2 className="font-semibold text-xl">Course Activity</h2>
            {/* If you have a chart component, replace the <img> with the chart */}
            <WeeklyCourseActivityChart/>
        </div>

        {/* Quick actions + top courses */}
        <aside className="space-y-6">
            <div className="bg-white rounded-2xl  space-y-6 p-6">
              <h3 className="text-lg font-semibold">Quick Actions</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <button onClick={() => setPopup(true)} className="px-4 py-2 rounded-lg font-semibold border-secondary-300 bg-secondary-100 border hover:bg-secondary-200">Add Instructor</button>
                <button onClick={() => setPopup(true)} className="px-4 py-2 rounded-lg font-semibold text-yellow-600 border-yellow-300 bg-yellow-100 border hover:bg-yellow-200">Add Department</button>
              </div>
          </div>
            <div className="bg-white rounded-2xl  space-y-6 ">
              <TopCourses />
          </div>
        </aside>
      </div>
            {popup && (
              <CreateUser onClose={() => setPopup(false)} />
            )}
    </div>
    </section>
  );
};

export default AdminDashboard;